export default function Notification({ notification }: any) {
  const formatDate = (dateString: string) => {
    return new Date(dateString)
      .toLocaleDateString("es-ES", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      })
      .replace(/\//g, "-")
      .replace(",", "")
      .replace(/\s/g, "");
  };

  return (
    <div className="notification-item">
      <div className="notification-header">
        <div className="notification-title-section">
          <h3 className="notification-title">{notification.title}</h3>
          <div className="notification-divider"></div>
        </div>
        <div className="notification-date">
          <span className="date-text">{formatDate(notification.createdDate)}</span>
        </div>
      </div>

      <div
        className="notification-content"
        dangerouslySetInnerHTML={{ __html: notification.notification }}
      />
    </div>
  );
}